<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router';

import Breadcrumb from 'primevue/breadcrumb';

import { useBreadcrumbs } from '../composables/useBreadcrumbs';

const { handleBreadcrumbs } = useBreadcrumbs();
</script>

<template>
  <Breadcrumb
    v-if="$route.meta.breadcrumb"
    :home="{
      icon: 'pi pi-home',
      url: '/',
    }"
    :model="handleBreadcrumbs()"
  >
    <template #item="{ item }">
      <RouterLink class="text-gray-600" :to="item.url">
        <i :class="item.icon" />

        {{ item.label }}
      </RouterLink>
    </template>
    <template #separator>
      <i class="pi pi-chevron-right" />
    </template>
  </Breadcrumb>
</template>
